import React from "react";
import FilterField from "./FilterField";
import FilterGroup from "./FilterGroup";
import FilterPanel from "./FilterPanel";

// Panneau de filtres rendu à partir de définitions groupées (useListPage) :
// même panneau pour toutes les listes, seules les définitions changent.
const ListFilters = ({
  id,
  open,
  groups = [],
  filters = {},
  onChange,
  onSet,
  onReset,
  canReset,
  ...panelProps
}) => (
  <FilterPanel id={id} open={open} onReset={onReset} canReset={canReset} {...panelProps}>
    {groups.map((group) => (
      <FilterGroup key={group.id} title={group.title}>
        {group.definitions.map((definition) => (
          <FilterField
            key={definition.name}
            definition={definition}
            value={filters[definition.name]}
            values={filters}
            onChange={onChange}
            onSet={onSet}
          />
        ))}
      </FilterGroup>
    ))}
  </FilterPanel>
);

export default ListFilters;
